import { render } from "./BookPetAppointmentPage.vue?vue&type=template&id=2bceb5d8&scoped=true"
import script from "./BookPetAppointmentPage.vue?vue&type=script&lang=js"
export * from "./BookPetAppointmentPage.vue?vue&type=script&lang=js"

import "./BookPetAppointmentPage.vue?vue&type=style&index=0&id=2bceb5d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bceb5d8"]])

export default __exports__